import * as React from 'react';
import { useDispatch, useSelector } from "react-redux";
import CardView from "./cardView";
import ListingView from "./listingView";
import { ListingViewConstants, NO_ACTIVITY_MESSAGE, NO_WORKKARD_MESSAGE, NO_DATA_FOUND } from './../../common/constants';
import ListingFilters from "../CardListing/listingFilters";
import { activityListingBulkActionHandler } from "../../containers/ActivityListing/slice";
import { showDialogueBox } from '../DialogueBox/actions';
import AcceptAndReassignActivity from "../AcceptReassignActivities";
import { showToast, hideToast } from '../../containers/SpockViewPage/actions/action';
import { ActivityBulkActions } from '../../containers/ActivityListing/constants';
import BodyPortal from '../BodyPortal';
import BottomMenu from "./bottomMenu";
const CardListing = (props) => {
    const dispatch = useDispatch();
    const isLoading = useSelector(state => state.isLoading);
    const sessionContext = useSelector(state => state.sessionContextOidc);

    const [showBulkActions, setShowBulkActions] = React.useState(false);
    const [selectedids, setSelectedids] = React.useState([]);
    const [selectedActivities, setSelectedActivities] = React.useState(0);
    const [isAllSelected, setIsAllSelected] = React.useState(false);
    const [isBottomMenuVisible, setIsBottomMenuVisible] = React.useState(false);
    const [selectedSortBy, setSelectedSortBy] = React.useState(props.sortBy);
    const [localIsSortDesc, setLocalIsSortDesc] = React.useState(props.isSortDesc);

    const sortOptionsRef = React.useRef(null);
    const toastPayload = React.useRef({
        message: "Select activities to Accept or Reject",
        type: "success",
        delayTime: 5000,
        showActions: false,
        isCloseIcon: true,
        autoClose: false
    });

    const renderView = (view) => {
        const { data, pagingModel, type, selectedTab } = props;
        switch (view) {
            case ListingViewConstants.CardView:
                return <CardView type={type} userTimezone={sessionContext?.userView.TimeZoneTz} tzData={sessionContext.tzData} data={data} onScrollHandler={props.onScrollHandler} />;
            case ListingViewConstants.ListView:
                return <ListingView type={type} data={data} selectedTab={selectedTab} pagingModel={pagingModel}
                        handleCheckboxChange={handleCheckboxChange}
                        selectedids={selectedids}
                        isAllSelected={isAllSelected}
                 />;
        }
    };

    const showBulkActionButtons = (showActions, newSelectedIds) => {
        document.querySelector(".tableHead").style.zIndex = showActions ? 13 : "unset";
        setShowBulkActions(showActions);
        setSelectedids(newSelectedIds);
        setSelectedActivities(newSelectedIds.length);
    };

    const handleCheckboxChange = (isChecked, allSelectedChecked, id) => {
        let newSelectedIds = [];
        let newIsAllSelected = false;
        if (allSelectedChecked) {
            if (isChecked) {
                newIsAllSelected = true;
                props.data.ActivitiesFullData.forEach(activity => newSelectedIds.push(activity.activityId));
            }
        } else {
            if (isChecked) {
                newSelectedIds = [...selectedids];
                newSelectedIds.push(id);
                if (newSelectedIds.length == props.data.ActivitiesFullData.length) {
                    newIsAllSelected = true;
                }
            } else {
                newSelectedIds = selectedids.filter(item => item != id);
            }
        }
        setIsAllSelected(newIsAllSelected);
        if (!newSelectedIds.length && props.selectedTab == "unassigned") {
            dispatch(showToast(toastPayload.current));
            showBulkActionButtons(false, newSelectedIds);
        } else {
            showBulkActionButtons(true, newSelectedIds);
            dispatch(hideToast());
        }
    };

    const handleActivityGridBulkAction = (type) => {
        dispatch(activityListingBulkActionHandler({ ids: JSON.stringify(selectedids), type }));
    };

    const openAcceptReassign = () => {
        dispatch(showDialogueBox({
            flag: true,
            title: `ACCEPT AND REASSIGN ${selectedActivities > 1 ? 'ACTIVITIES' : 'ACTIVITY'}`,
            modalClassNames: 'save-as-popup',
            component: (
                <AcceptAndReassignActivity
                    activityIds={selectedids}
                    isMulti={selectedActivities > 1}
                />
            ),
            shouldCloseOnOverlayClick: true
        }));
    };

    const showBottomMenu = (data) => {
        if (props.type == "WORKKARD") {
            sortOptionsRef.current = [
                { label: "Created date ASC", iconName: "Upascendings", isSortDesc: false, sortBy: 1 },
                { label: "Created date DESC", iconName: "Decendings", isSortDesc: true, sortBy: 1 },
                { label: "Workkard number A to Z", iconName: "A2ZSort", isSortDesc: false, sortBy: 2 },
                { label: "Workkard number Z to A", iconName: "Z2ASort", isSortDesc: true, sortBy: 2 }
            ];
        } else {
            sortOptionsRef.current = [
                { label: "Created date ASC", iconName: "Upascendings", isSortDesc: false, sortBy: 1 },
                { label: "Created date DESC", iconName: "Decendings", isSortDesc: true, sortBy: 1 },
                { label: "Skill set A to Z", iconName: "A2ZSort", isSortDesc: false, sortBy: 3 },
                { label: "Skill set Z to A", iconName: "Z2ASort", isSortDesc: true, sortBy: 3 },
                { label: "Due date ASC", iconName: "Upascendings", isSortDesc: false, sortBy: 4 },
                { label: "Due date DESC", iconName: "Decendings", isSortDesc: true, sortBy: 4 }
            ];
        }
        setIsBottomMenuVisible(data);
    };

    const onSortByClick = (sortBy, isSortDesc) => {
        switch (sortBy) {
            case 1:
            case 2:
            case 3:
            case 4:
                if (selectedSortBy == sortBy && localIsSortDesc == isSortDesc) {
                    setIsBottomMenuVisible(false);
                } else {
                    isSortDesc == true ? props.handleSorting(sortBy) : props.toggleSortingDir(sortBy, isSortDesc);
                    setSelectedSortBy(sortBy);
                    setLocalIsSortDesc(isSortDesc);
                    setIsBottomMenuVisible(false);
                }
                break;
            default:
        }
    };


    const { data, view, type, selectedTab, tabCounts, onTabClick, sortOptions, search, sortBy, isSortDesc, searchText } = props;
    let nodatamsg = '';
    if (searchText && searchText != "") {
        nodatamsg = NO_DATA_FOUND;
    } else {
        if (type === ListingViewConstants.Activity)
            nodatamsg = NO_ACTIVITY_MESSAGE[selectedTab.toLowerCase()];
        else
            nodatamsg = NO_WORKKARD_MESSAGE[selectedTab.toLowerCase()];
    }

    return (
        <>
            <div className="cardViewFilterBlock">
                {(showBulkActions && type === ListingViewConstants.Activity && view === ListingViewConstants.ListView && selectedTab === "unassigned") &&
                    <div className="bulkAction rowFlex animated fast slideInUp alignMiddle ml" data-test="listingBulkAction">
                        <div className="flexGrow">
                            {data.menuList && data.menuList.includes(ActivityBulkActions.Accept) && <a href="javascript:void(0);" onClick={() => handleActivityGridBulkAction("AcceptActivity")} className="btn btnSmall buttonGradient">Accept</a>}
                            {data.menuList && data.menuList.includes(ActivityBulkActions.AcceptReassign) && <a href="javascript:void(0);" onClick={openAcceptReassign} className="btn btnSmall buttonGradient">Accept &amp; Reassign</a>}
                            {data.menuList && data.menuList.includes(ActivityBulkActions.Reject) && <a href="javascript:void(0);" onClick={() => handleActivityGridBulkAction("RejectActivity")} className="btn btnSmall btnRed">Reject</a>}
                        </div>
                        <div className="mr__1">{selectedActivities}{selectedActivities == 1 ? ' activity' : ' activities'} selected</div>
                    </div>}
                <ListingFilters
                    tabCounts={tabCounts}
                    selectedTab={selectedTab}
                    onTabClick={onTabClick}
                    sortOptions={sortOptions}
                    onChangeSearchQuery={props.onChangeSearchQuery}
                    search={search}
                    sortBy={sortBy}
                    handleSorting={props.handleSorting}
                    isSortDesc={isSortDesc}
                    toggleSortingDir={props.toggleSortingDir}
                    handleViewChange={props.handleViewChange}
                    view={view}
                    type={type}
                    searchText={searchText}
                    showBottomMenu={(data) => showBottomMenu(data)}
                />
            </div>
            {props.data.Total > 0 ? renderView(view) :
                (!isLoading &&
                    <div className="workKardScroll scrollArea noDataFound"><div className="emptyScreen"><h2>{nodatamsg}</h2></div></div>)
            }
            {
                isBottomMenuVisible ?
                    <BodyPortal>
                        <BottomMenu showBottomMenu={(data) => showBottomMenu(data)} selectedSortBy={selectedSortBy} isSortDesc={localIsSortDesc} onSortByClick={(sortBy, isSortDesc) => onSortByClick(sortBy, isSortDesc)} sortOptions={sortOptionsRef.current} />
                    </BodyPortal>
                    : null
            }
        </>
    );
};

export default CardListing;